/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function SpeechIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="speech"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M10 20.5L9.5 16.5L10.717 16.674C11.922 16.846 13 15.911 13 14.694L13 8.266C13 8.089 12.989 7.912 12.967 7.736C12.7 5.602 10.886 4 8.734 4L8.227 4C5.407 4 3.185 6.4 3.401 9.212L3.423 9.502C3.474 10.161 3.652 10.804 3.948 11.395L4.721 12.941C4.903 13.305 4.969 13.716 4.912 14.118L4 20.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16 10A5.105 5.105 0 0 1 16 14" data-tinysvg-shape="arc" data-tinysvg-arc="11.303 12 5.105 5.105 336.933 383.066 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.5 8A8.656 8.656 0 0 1 18.5 16" data-tinysvg-shape="arc" data-tinysvg-arc="10.823 12 8.656 8.656 332.479 387.522 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
